import * as React from "react";
import { Button } from "ui/components";
import { copyStringToClipboard } from "utils/copyToClipboard";
import { cx } from "utils/join-classnames";
import styles from "./TextField.module.scss";

type Props = {
    value: string;
    theme: string;
    defaultText: string;
    onValueChanged?(value: string): void;
    id?: string;
    valid?: boolean;
    disabled?: boolean;
    focus?: boolean;
    copiable?: boolean;
    className?: string;
};

const TextField: React.FC<Props> = ({
    value,
    theme,
    defaultText,
    onValueChanged,
    id,
    valid,
    disabled,
    focus,
    copiable,
    className,
}) => {
    const inputRef = React.useRef<HTMLInputElement>(null);
    const [tooltipText, setTooltipText] =
        React.useState<string>("Copy to clipboard");

    React.useEffect(() => {
        if (!focus || !inputRef.current) {
            return;
        }
        inputRef.current.focus();
    }, []);

    const copyToClipboard = () => {
        setTimeout(() => {
            setTooltipText("Copy to clipboard");
        }, 1000);
        setTooltipText("Copied to clipboard!");
        copyStringToClipboard(value);
    };

    return (
        <div className={styles.copyInput}>
            <input
                type="text"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    onValueChanged && onValueChanged(e.target.value)
                }
                className={cx(
                    styles.textfield,
                    theme === "dark"
                        ? styles.textfield__dark
                        : styles.textfield__light,
                    !valid && valid !== undefined && styles.textfield__invalid,
                    className,
                )}
                value={value}
                placeholder={defaultText}
                id={id}
                disabled={disabled}
                ref={inputRef}
            />
            {copiable && (
                <Button
                    type="icon"
                    icon="copy"
                    onClick={copyToClipboard}
                    size="large"
                    tooltip={tooltipText}
                />
            )}
        </div>
    );
};

export default TextField;
